<template lang="pug">
  div
    div.row
      div.col-10
        div.form-inline
          h4 <kbd>區間超速認證資訊</kbd>
          p &nbsp &nbsp 
          div(v-for="item in paras")
            h4 <kbd class="navbar-brand-kbd">固定桿代碼{{item.fixed_link_code}}  道路限速{{item.road_speed_limit}} 舉發車速(超速){{item.break_value}} 舉發車速(龜速){{item.break_value_slow}}</kbd>
          p &nbsp &nbsp &nbsp &nbsp
          div
            <input type="radio" id="radio1" name="radios" value="t1" checked v-model="radioValue">
              <label for="radio1">違規</label>
            <input type="radio" id="radio2" name="radios" value="t23" checked v-model="radioValue">
              <label for="radio2">未違規&無法開單</label>
        div(v-if="waitConfirmFlag==true && loadingData==true")
          h1.text-center.display-4 認證資料處理中
        div
          vuetable(
            ref="vuetable"
            :api-url="`${server}/api/interval-speed-data/`"
            data-path="results"
            pagination-path=""
            :per-page=1000
            :fields="fields"
            :css="boostrapCss"
            :http-options="httpOptions"
            :append-params="moreParams"
            detail-row-component="confirm-check-detail"
            :sortOrder="sortOrder"
            @vuetable:loading="onLoading"
            @vuetable:loaded="onLoaded"
            @vuetable:pagination-data="onPaginationData"
            @vuetable:cell-clicked="onCellClicked")
              //-20220307 add
              <template slot-scope="props" slot="index">
                span {{(props.rowIndex+1)+(currentPage-1)*1000}}
              </template>
          vuetable-pagination(
            ref="pagination"
            @vuetable-pagination:change-page="onChangePage"
            :css="boostrapCss.pagination" 
          )
        div(v-if="tableDataLen==0 && loadingData==false")
          h1.text-center.display-4 今日無認證資料
      div.col-2
        h3.text-info <strong>請輸入查詢區間</strong>    
        div.form-group
          div.form-group
            label 開始時間
            input.form-control.form-control-sm(type="date" v-model="startDate")
          div.form-group
            label 結束時間
            input.form-control.form-control-sm(type="date" v-model="endDate")
          div.form-group
            label 過濾條件
            input.form-control.form-control-sm(type="text" v-model="queryString" placeholder="輸入車號")
          button.btn.btn-primary.mb-2.w-100(@click="onFilterSet" type="submit") 篩選
          button.btn.btn-danger.mb-2.w-100(@click="confirmTicket" type="submit" :disabled=("tableDataLen==0 || waitConfirmFlag==true  || radioValue!='t1'")) 開單確認
          button.btn.btn-warning.mb-2.w-100(@click="downloadErrorImg" type="submit") 下載無法開單照片
        Loader(v-if="loadingData") 
          h4 資料載入中，請稍等
    
</template>

<script>
import moment from 'moment';
import axios from 'axios';
import Vue from 'vue';
import VuetablePagination from 'vuetable-2/src/components/VuetablePagination';
import { mapState } from 'vuex';
import Vuetable from 'vuetable-2/src/components/Vuetable';
import readCookie from '@/vuex/functions/readCookie';
import server from '@/config';
import Loader from '../../common/Loader';
import ConfirmCheckDetail from './ConfirmCheckDetail';

Vue.component('confirm-check-detail', ConfirmCheckDetail);

export default {
  name: 'CarConfirmList',
  data() {
    return {
      //20220307 add
      currentPage: 1,
      radioValue: 't1',
      statusType: 't1',
      waitConfirmFlag: false,
      tableConfirmData: [],
      tableDataLen: undefined,
      tmpId: '',
      startDate: undefined,
      endDate: undefined,
      loadingData: false,
      paras: [],
      boostrapCss: {
        tableClass: 'table table-striped table-sm',
        loadingClass: 'loading',
        ascendingIcon: 'glyphicon glyphicon-chevron-up',
        descendingIcon: 'glyphicon glyphicon-chevron-down',
        handleIcon: 'glyphicon glyphicon-menu-hamburger',
        pagination: {
          infoClass: '',
          wrapperClass: 'pagination',
          activeClass: 'page-active',
          disabledClass: 'disabled',
          pageClass: 'page-link',
          linkClass: 'page-link',
          icons: {
            first: '',
            prev: '',
            next: '',
            last: '',
          },
        },
      },
      httpOptions: {
        headers: {
          Authorization: `Token ${readCookie('Token')}`,
        },
      },
      server,
      fields: [
        //20220307 add
        {
          name: '__slot:index',
          title: '序號',
        },
        /*
        {
          name: 'xactno',
          sortField: 'xactno',
          title: '流水號',
        },
        */
        {
          name: 'plt_no.plt_no',
          //sortField: 'plt_no.plt_no',
          title: '車牌號碼',
        },
        /*
        {
          name: 'car_tp.car_tp',
          sortField: 'car_tp__car_tp',
          title: '車別代碼',
        },
        */
        {
          name: 'vli_dateTime_in',
          sortField: 'vli_dateTime_in',
          title: '進入時間',
          callback: this.readableDate,
        },
        {
          name: 'vli_dateTime_out',
          sortField: 'vli_dateTime_out',
          title: '離開時間',
          callback: this.readableDate,
        },
        {
          name: 'pass_time',
          title: '通過時間(秒)',
        },
        {
          name: 'speed',
          sortField: 'speed',
          title: '車速',
        },
        {
          name: 'fixed_link_code.fixed_link_code',
          title: '固定桿代碼',
        },
        {
          name: 'rule_code.rule_code',
          title: '條款代碼',
        },
        {
          name: 'status',
          title: '開單狀態',
          sortField: 'status',
          callback: this.status,
        },
        {
          name: 'user',
          sortField: 'user',
          title: '認證人員',
          //callback: this.status,
        },
        /*
        {
          name: 'reviewer',
          sortField: 'reviewer',
          title: '開單人員',
        },
        */
      ],
      sortOrder: [
        {
          sortField: 'car_tp__car_tp',
          direction: 'asc',
        },
      ],
      queryString: '',
      moreParams: {
        fixed_link_code_id: this.$store.state.user.user.department.fixed_link_code,
        status: 't1',
        user: this.$store.state.user.user.username,
        start_date: moment().format('YYYY-MM-DD'),
        end_date: moment().format('YYYY-MM-DD'),
        department: this.$store.state.user.user.department.name,
        checked: false,
      },
    };
  },
  components: {
    Vuetable,
    VuetablePagination,
    Loader,
  },
  async mounted() {
    //this.loadingData = true;
    await this.getPara();
    //this.loadingData = false;
  },
  watch: {
    startDate(val) {
      if (val > this.endDate && this.endDate !== '') {
        this.$store.commit('SET_MESSAGE', {
          type: 'warn',
          context: '開始時間不可晚於結束時間',
        });
        this.startDate = this.endDate;
      }
    },
    endDate(val) {
      if (val < this.startDate && this.startDate !== '') {
        this.$store.commit('SET_MESSAGE', {
          type: 'warn',
          context: '結束時間不可早於開始時間',
        });
        this.endDate = this.startDate;
      }
    },
  },
  methods: {
    onLoading() {
      this.loadingData = true;
      console.log('loading... show your spinner here');
    },
    onLoaded() {
      this.loadingData = false;
      console.log('loaded! .. hide your spinner here');
      this.tableDataLen=this.$refs.vuetable.tableData.length;
      this.tableConfirmData=this.$refs.vuetable.tableData;
      console.log('datalen:',this.tableDataLen);
      if(this.tableDataLen>0) {
        console.log('id:',this.$refs.vuetable.tableData[0].id);
        this.onCellClicked(this.$refs.vuetable.tableData[0]);
      }
    },
    onCellClicked(data, field, event) {
      console.log('cellclicked');
      console.log('tmpId:',this.tmpId);
      console.log('nowId:',data.id);
      console.log('vuetable:',this.$refs.vuetable);
      if(this.tmpId=='')
        this.tmpId=data.id;
      else if(this.tmpId !== '' && this.tmpId != data.id)
      {
        this.$refs.vuetable.toggleDetailRow(this.tmpId);
        this.tmpId=data.id;
      }
      else if(this.tmpId == data.id)
        this.tmpId = '';   
      //this.$refs.vuetable.toggleDetailRow(data.id);
      setTimeout(() => {
        this.$refs.vuetable.toggleDetailRow(data.id);
      }, 50);
    },
    onPaginationData(paginationData) {
      this.currentPage = paginationData.current_page;
      this.$refs.pagination.setPaginationData(paginationData);
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    downloadErrorImg() {
      if (this.startDate == undefined || this.endDate == undefined) {
        this.$store.commit('SET_MESSAGE', {
          type: 'warn',
          context: '請輸入查詢區間',
        });
        return;
      }
      window.open(`${server}/download1236/download-zip-file/?fid=${this.$store.state.user.user.department.fixed_link_code}&start=${this.startDate}&end=${this.endDate}`, '_blank');
    },
    async confirmTicket() {
      this.loadingData = true;
      this.waitConfirmFlag=true;
      const recordIDList=[];
      console.log('this.tableConfirmData:',this.tableConfirmData)
      this.tableConfirmData.forEach((item) => {  
        recordIDList.push(item.id);
      });
      await this.instance.patch(`/api/interval-speed-data/${recordIDList[0]}/`, {
        recordIDList: recordIDList,
        reviewer: this.$store.state.user.user.username,
      })
      .then((res) => {
        //this.$parent.refresh();
        console.log(res.data);
        window.open(`${server}/download1236/download-zip-file/?zipFile=${res.data}`, '_blank');
        /*this.$store.commit('SET_MESSAGE', {
          type: 'success',
          context: '更新成功, 已開單',
        });*/
        const vm = this;
        Vue.nextTick(() => this.$refs.vuetable.refresh());
      })
      .catch((err) => {
        this.$store.commit('SET_MESSAGE', {
          type: 'error',
          //context: err.response.data,
          context: '錯誤,無法開單'
          //context: err
        });
      });
      this.waitConfirmFlag=false;   
      this.loadingData = false;     
    },  
    onFilterSet() {
      if (this.startDate == undefined || this.endDate == undefined) {
        this.$store.commit('SET_MESSAGE', {
          type: 'warn',
          context: '請輸入查詢區間',
        });
        return;
      }
      console.log('start:',this.startDate);
      console.log('end:',this.endDate);
      /*
      if(this.queryString=="尚未處理")
          this.queryString="t0"
        else if(this.queryString=="已開單")
          this.queryString="t1"
        else if(this.queryString=="未違規")
          this.queryString="t2"  
        else if(this.queryString=="無法開單")
          this.queryString="t3" 
      */
      this.moreParams = {
        search: this.queryString,
        fixed_link_code_id: this.$store.state.user.user.department.fixed_link_code,
        //status: 't1',
        status: this.statusType,
        user: this.$store.state.user.user.username,
        start_date: this.startDate,
        end_date: this.endDate,
        department: this.$store.state.user.user.department.name,
        checked: false,
      };
      const vm = this;
      Vue.nextTick(() => this.$refs.vuetable.refresh());
    },
    getSortParam(sortOrder) {
      return sortOrder.map((sort) => {
        return (sort.direction === 'desc' ? '-' : '') + sort.sortField;
      }).join(',');
    },
    readableDate(value) {
      return moment(value).format('YY/MM/DD HH:mm:ss.SSS'); //0~23hr format
    },
    /*
    status(value) {
      if(value=="t0")
        return "尚未處理"
      else if(value=="t1")
        return "已開單"
      else if(value=="t2")
        return "未違規"
      else if(value=="t3")
        return "無法開單"
    },
    */
    getPara() {
      return this.instance.get('/api/fixed-link-code/', {
        params: {
          fixed_link_code_id: this.$store.state.user.user.department.fixed_link_code,
        },
      })
      .then((res) => {
        this.paras = res.data;
      });
    },
  },
  computed: {
    instance() {
      return this.$store.state.instance;
    },
    user() {
      return this.$store.state.user;
    },
    //tableDataLen() {
    //  return this.$refs.vuetable.tableData.length;
    //},
  },
  watch: {
    async radioValue(val) {
      this.loadingData = true;
      this.statusType=val;
      console.log('statusType:',this.statusType);
      this.moreParams['status']=this.statusType;
      console.log('this.moreParams:',this.moreParams);
      await this.instance.get('/api/interval-speed-data/', this.moreParams)
      .then(() => {
        const vm = this;
        Vue.nextTick(() => this.$refs.vuetable.refresh());
      })
      .catch((err) => {
        this.$store.commit('SET_MESSAGE', {
          type: 'error',
          context: err.response.data,
        });
      });
      this.loadingData = false;
    }
  },
  // computed: mapState({
  //   system: state => state.system,
  // }),
};
</script>

<style lang="sass" scoped>
.user-layout-head
  margin-bottom: 10px

.navbar-brand-kbd
  background-color: #00695C;  // Changes background color
  color: white;                  // Changes text color

th.sortable
  color: #ec971f;

input[type=radio]
  display: none;

input[type=radio]+label
  display: inline-block;
  margin: -2px;
  padding: 4px 12px;
  margin-bottom: 0;
  font-size: 20px;
  line-height: 20px;
  color: #333;
  text-align: center;
  text-shadow: 0 1px 1px rgba(255,255,255,0.75);
  vertical-align: middle;
  cursor: pointer;
  background-color: #f5f5f5;
  background-image: -moz-linear-gradient(top,#fff,#e6e6e6);
  background-image: -webkit-gradient(linear,0 0,0 100%,from(#fff),to(#e6e6e6));
  background-image: -webkit-linear-gradient(top,#fff,#e6e6e6);
  background-image: -o-linear-gradient(top,#fff,#e6e6e6);
  background-image: linear-gradient(to bottom,#fff,#e6e6e6);
  background-repeat: repeat-x;
  border: 1px solid #ccc;
  border-color: #e6e6e6 #e6e6e6 #bfbfbf;
  border-color: rgba(0,0,0,0.1) rgba(0,0,0,0.1) rgba(0,0,0,0.25);
  border-bottom-color: #b3b3b3;
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ffffffff',endColorstr='#ffe6e6e6',GradientType=0);
  filter: progid:DXImageTransform.Microsoft.gradient(enabled=false);
  -webkit-box-shadow: inset 0 2px 4px rgba(0,0,0,0.15),0 1px 2px rgba(0,0,0,0.05);
  -moz-box-shadow: inset 0 2px 4px rgba(0,0,0,0.15),0 1px 2px rgba(0,0,0,0.05);
  box-shadow: inset 0 1px 0 rgba(255,255,255,0.2),0 1px 2px rgba(0,0,0,0.05);

input[type=radio]:checked+label
  background-image: none;
  outline: 0;
  -webkit-box-shadow: inset 0 2px 4px rgba(0,0,0,0.15),0 1px 2px rgba(0,0,0,0.05);
  -moz-box-shadow: inset 0 2px 4px rgba(0,0,0,0.15),0 1px 2px rgba(0,0,0,0.05);
  box-shadow: inset 0 2px 4px rgba(0,0,0,0.15),0 1px 2px rgba(0,0,0,0.05);
  background-color: #e0e0e0;

</style>




// WEBPACK FOOTER //
// CarConfirmList.vue?330adb72